<div class="st-page">
  <a class="st-back-link" (click)="goBack()"><i class="ri-arrow-left-line"></i> {{ 'backToClass' | translate }}</a>

  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'classDiary' | translate }}</h1>
      <p class="st-subtitle">{{ 'homeworkNoticesAndNotes' | translate }}</p>
    </div>
    <button class="st-btn st-btn-primary" *ngIf="allowCreateDiary" (click)="openCreateDiaryForm()"><i class="ri-add-line"></i> {{ 'newEntry' | translate }}</button>
  </div>

  <div class="scd-tab-row">
    <div class="st-tabs">
      <div class="st-tab" [class.active]="tabName === 'Past'" (click)="setTab('Past')">{{ 'past' | translate }}</div>
      <div class="st-tab" [class.active]="tabName === 'Today'" (click)="setTab('Today')">{{ 'today' | translate }}</div>
      <div class="st-tab" [class.active]="tabName === 'Upcoming'" (click)="setTab('Upcoming')">{{ 'upcoming' | translate }}</div>
    </div>

    <span class="scd-date-chip" *ngIf="showDateSelector">
      <p-calendar [(ngModel)]="pickedDate" [ngModelOptions]="{standalone: true}"
        dateFormat="dd M yy" [minDate]="calendarMinDate" [maxDate]="calendarMaxDate"
        [showClear]="true" appendTo="body" placeholder="{{ 'allDates' | translate }}" readonlyInput="true"
        (onSelect)="onDatePicked()" (onClear)="selectAllDates()" styleClass="scd-calendar-input"></p-calendar>
      <i class="ri-calendar-line scd-calendar-icon"></i>
    </span>
  </div>

  <div class="scd-filter-row" *ngIf="subjectListForFilter.length">
    <button class="scd-filter-chip" [class.active]="selectedSubjectId === null" (click)="selectSubject(null)">{{ 'all' | translate }}</button>
    <button class="scd-filter-chip" *ngFor="let s of subjectListForFilter" [class.active]="selectedSubjectId === s.subjectId" (click)="selectSubject(s.subjectId)">
      {{ s.subject }}
    </button>
  </div>

  <ng-container *ngIf="loading">
    <div class="scd-diary-card scd-skeleton-card" *ngFor="let _ of [1,2,3,4]">
      <div class="scd-diary-accent"></div>
      <div class="scd-diary-body">
        <div class="scd-skeleton-line scd-skeleton-line-title"></div>
        <div class="scd-skeleton-line scd-skeleton-line-sub"></div>
      </div>
    </div>
  </ng-container>

  <div class="st-empty-state" *ngIf="!loading && loadError">
    <i class="ri-error-warning-line"></i> {{ 'couldntLoadTheDiaryPleaseTryAgain' | translate }}
  </div>

  <div class="st-empty-state" *ngIf="!loading && !loadError && diaryEntries.length === 0">
    <i class="ri-file-list-line"></i> {{ 'noDiaryEntriesYet' | translate }}
  </div>

  <ng-container *ngIf="!loading">
  <div class="scd-diary-card" *ngFor="let e of diaryEntries" (click)="openDiaryEntry(e)">
    <div class="scd-diary-accent"></div>
    <div class="scd-diary-body">
      <div class="scd-diary-top">
        <div class="scd-diary-top-left">
          <div class="scd-diary-title">
            {{ e.diaryTitle || ('notThere' | translate) }}
            <i class="ri-attachment-line" *ngIf="e.isAttachmentWithDiary"></i>
          </div>
          <span class="scd-diary-subject-pill"><i class="ri-book-open-line"></i> {{ e.subject }}</span>
        </div>
        <div class="scd-diary-top-right">
          <span class="scd-diary-percent">{{ e.homeworkDonePercentage }}%</span>
          <span class="scd-diary-seen-label">{{ 'seen' | translate }}</span>
          <div class="scd-diary-percent-track">
            <div class="scd-diary-percent-fill" [style.width.%]="e.homeworkDonePercentage"></div>
          </div>
        </div>
      </div>

      <div class="scd-diary-divider"></div>

      <div class="scd-diary-bottom">
        <div class="scd-diary-staff">
          <div class="st-avatar">
            <img *ngIf="e.staffImage" [src]="e.staffImage" alt="" />
          </div>
          <div>
            <div class="scd-diary-staff-name">{{ e.staffName }}</div>
            <div class="scd-diary-staff-role">{{ 'classTeacher' | translate }}</div>
          </div>
        </div>
        <div class="scd-diary-due-pill">
          <i class="ri-calendar-line"></i>
          <div>
            <div class="scd-diary-due-label">{{ 'dueDate' | translate }}</div>
            <div class="scd-diary-due-value">{{ formatDate(e.dueDate) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </ng-container>

  <div class="scd-load-more" *ngIf="!loading && diaryEntries.length > 10 && maxPageNumber > pageNumber">
    <button class="st-btn st-btn-secondary" [disabled]="loadingMore" (click)="loadMore()">
      {{ loadingMore ? ('loading' | translate) : ('loadMore' | translate) }}
    </button>
  </div>
</div>

<!-- Diary detail side drawer (DiaryDetailedView) -->
<div class="scd-drawer-overlay scd-drawer-overlay-full" *ngIf="showDetailDrawer" (click)="closeDetailDrawer()">
  <div class="scd-drawer scd-detail-drawer" (click)="$event.stopPropagation()">
    <div class="scd-drawer-head">
      <div>
        <h3>{{ detailSubject }}</h3>
        <p class="st-subtitle">{{ 'diaryDetails' | translate }}</p>
      </div>
      <div class="scd-drawer-head-actions">
        <button class="scd-close-btn" *ngIf="diaryDetail?.isStaffAllowedToEditDiary" (click)="openEditDiaryForm()" title="{{ 'edit' | translate }}">
          <i class="ri-pencil-line"></i>
        </button>
        <button class="scd-close-btn" (click)="closeDetailDrawer()"><i class="ri-close-line"></i></button>
      </div>
    </div>

    <div class="scd-drawer-body">
      <div class="st-empty-state" *ngIf="detailLoading">
        <i class="ri-loader-4-line ri-spin"></i> {{ 'loadingDiary' | translate }}
      </div>

      <div class="st-empty-state" *ngIf="!detailLoading && detailLoadError">
        <i class="ri-error-warning-line"></i> {{ 'couldntLoadThisDiaryEntry' | translate }}
      </div>

      <ng-container *ngIf="!detailLoading && !detailLoadError && diaryDetailInfo">
        <div class="st-card">
          <h3 class="st-card-title">{{ diaryDetailInfo.diaryTitle }}</h3>
          <p class="scd-detail-desc" *ngIf="diaryDetailInfo.diaryDescription">{{ diaryDetailInfo.diaryDescription }}</p>
          <div class="scd-detail-meta-row">
            <div *ngIf="diaryDetailInfo.diaryDuration">
              <span class="st-info-label">{{ 'duration' | translate }}</span>
              <span class="st-info-value">{{ formatDuration(diaryDetailInfo.diaryDuration) }}</span>
            </div>
            <div>
              <span class="st-info-label">{{ 'submissionDate' | translate }}</span>
              <span class="st-info-value">{{ diaryDetailInfo.submissionDate }}</span>
            </div>
          </div>
        </div>

        <div class="st-card" *ngIf="imagesArray.length || pdfArray.length">
          <h3 class="st-card-title" *ngIf="imagesArray.length">{{ 'images' | translate }}</h3>
          <div class="scd-media-grid" *ngIf="imagesArray.length">
            <div class="scd-media-thumb" *ngFor="let img of imagesArray; let i = index" (click)="openImageViewer(i)">
              <img [src]="img.DiaryMediaBlurUrl" alt="" />
            </div>
          </div>

          <h3 class="st-card-title" *ngIf="pdfArray.length">{{ 'documents' | translate }}</h3>
          <div class="scd-media-grid" *ngIf="pdfArray.length">
            <div class="scd-media-thumb scd-media-pdf" *ngFor="let doc of pdfArray" (click)="openPdfViewer(doc)">
              <i class="ri-file-pdf-line"></i>
            </div>
          </div>
        </div>

        <div class="st-card scd-summary-card" (click)="openStudentSheet('notCompleted')">
          <div class="scd-summary-row">
            <div class="scd-summary-stat">
              <span class="scd-summary-value scd-summary-green">{{ diaryDetail?.diaryCompletedStudentDetails?.length || 0 }}</span>
              <span class="st-info-label">{{ 'completed' | translate }}</span>
            </div>
            <div class="scd-summary-stat">
              <span class="scd-summary-value scd-summary-red">{{ diaryDetail?.diaryNotCompletedStudentDetails?.length || 0 }}</span>
              <span class="st-info-label">{{ 'notCompleted' | translate }}</span>
            </div>
          </div>
          <div class="scd-diary-percent-track" style="margin-top:12px;">
            <div class="scd-diary-percent-fill" [style.width.%]="diaryDetailInfo.homeworkDonePercentage"></div>
          </div>
          <div class="st-list-sub" style="margin-top:8px;">{{ 'tapToSeeStudentList' | translate }} <i class="ri-arrow-right-s-line"></i></div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Image gallery viewer -->
<div class="scd-lightbox-overlay" *ngIf="showImageViewer" (click)="closeImageViewer()">
  <button class="scd-lightbox-close" (click)="closeImageViewer()"><i class="ri-close-line"></i></button>
  <div class="scd-gallery-counter" *ngIf="imagesArray.length > 1">{{ imageViewerIndex + 1 }} / {{ imagesArray.length }}</div>
  <button class="scd-gallery-nav scd-gallery-prev" *ngIf="imageViewerIndex > 0" (click)="imageViewerPrev($event)">
    <i class="ri-arrow-left-s-line"></i>
  </button>
  <div class="scd-lightbox-content" (click)="$event.stopPropagation()">
    <img [src]="imagesArray[imageViewerIndex]?.DiaryMediaUrl" class="scd-lightbox-image" alt="" />
  </div>
  <button class="scd-gallery-nav scd-gallery-next" *ngIf="imageViewerIndex < imagesArray.length - 1" (click)="imageViewerNext($event)">
    <i class="ri-arrow-right-s-line"></i>
  </button>
</div>

<!-- PDF viewer -->
<div class="scd-lightbox-overlay" *ngIf="showPdfViewer" (click)="closePdfViewer()">
  <button class="scd-lightbox-close" (click)="closePdfViewer()"><i class="ri-close-line"></i></button>
  <button class="scd-pdf-download-btn" (click)="downloadAttachment(pdfViewerUrl); $event.stopPropagation()">
    <i class="ri-download-line"></i>
  </button>
  <div class="scd-lightbox-content" (click)="$event.stopPropagation()">
    <iframe [src]="pdfSafeUrl" class="scd-lightbox-frame"></iframe>
  </div>
</div>

<!-- Student completion sheet -->
<div class="scd-drawer-overlay" *ngIf="showStudentSheet" (click)="closeStudentSheet()">
  <div class="scd-drawer scd-student-sheet" (click)="$event.stopPropagation()">
    <div class="scd-drawer-head">
      <h3>{{ 'students' | translate }}</h3>
      <button class="scd-close-btn" (click)="closeStudentSheet()"><i class="ri-close-line"></i></button>
    </div>

    <div class="scd-student-tabs">
      <button class="scd-student-tab" [class.active]="studentTab === 'completed'" (click)="setStudentTab('completed')">
        {{ 'completed' | translate }} ({{ diaryDetail?.diaryCompletedStudentDetails?.length || 0 }})
      </button>
      <button class="scd-student-tab" [class.active]="studentTab === 'notCompleted'" (click)="setStudentTab('notCompleted')">
        {{ 'notCompleted' | translate }} ({{ diaryDetail?.diaryNotCompletedStudentDetails?.length || 0 }})
      </button>
    </div>

    <div class="scd-student-search">
      <i class="ri-search-line"></i>
      <input type="text" placeholder="{{ 'searchStudentsEllipsis' | translate }}" [(ngModel)]="studentSearchQuery" (ngModelChange)="onStudentSearchChange()" />
    </div>

    <div class="scd-drawer-body">
      <div class="st-empty-state" *ngIf="filteredStudents.length === 0">
        <i class="ri-group-line"></i> {{ 'noStudentsFound' | translate }}
      </div>
      <div class="st-list-row" *ngFor="let s of filteredStudents">
        <div class="st-avatar">
          <img *ngIf="s.studentImage" [src]="s.studentImage" alt="" />
        </div>
        <div class="st-list-text">
          <div class="st-list-title">{{ s.studentName }}</div>
          <div class="st-list-sub" *ngIf="studentTab === 'notCompleted'">{{ 'rollNo' | translate }} {{ s.rollNumber }}</div>
          <div class="st-list-sub" *ngIf="studentTab === 'completed'">{{ s.classNumber }} {{ s.classDivision }} &middot; {{ s.classTeacherName }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create / Edit Diary form drawer -->
<div class="scd-drawer-overlay scd-drawer-overlay-full" *ngIf="showFormDrawer" (click)="closeFormDrawer()">
  <div class="scd-drawer scd-form-drawer" (click)="$event.stopPropagation()">
    <div class="scd-drawer-head">
      <h3>{{ (formMode === 'create' ? 'createDiary' : 'updateDiary') | translate }}</h3>
      <button class="scd-close-btn" (click)="closeFormDrawer()"><i class="ri-close-line"></i></button>
    </div>

    <div class="scd-drawer-body">
      <div class="scd-form-field">
        <label class="scd-form-label">{{ 'subject' | translate }} <span class="scd-required">*</span></label>
        <select class="scd-form-select" [(ngModel)]="formSubjectId" [disabled]="formSubjectLocked" (ngModelChange)="onFormSubjectChange()">
          <option [ngValue]="null" disabled>{{ 'selectSubject' | translate }}</option>
          <option *ngFor="let s of formSubjectOptions" [ngValue]="s.subjectId">{{ s.subject }}</option>
        </select>
      </div>

      <div class="scd-form-field">
        <label class="scd-form-label">{{ 'title' | translate }} <span class="scd-required">*</span></label>
        <input type="text" class="scd-form-input" [(ngModel)]="formTitle" placeholder="{{ 'egCompleteTable1To10' | translate }}" />
      </div>

      <div class="scd-form-field">
        <label class="scd-form-label">{{ 'assignmentDescription' | translate }} <span class="scd-required">*</span></label>
        <textarea class="scd-form-textarea" rows="4" [(ngModel)]="formDescription" placeholder="{{ 'egSolveExercise42Questions1To10FromTheTextbook' | translate }}"></textarea>
      </div>

      <div class="scd-form-field">
        <label class="scd-form-label">{{ 'duration' | translate }}</label>
        <div class="scd-form-duration-row">
          <input type="number" class="scd-form-input" min="0" [(ngModel)]="formDurationHours" placeholder="{{ 'eg1' | translate }}" />
          <input type="number" class="scd-form-input" min="0" max="59" [(ngModel)]="formDurationMinutes" placeholder="{{ 'eg30' | translate }}" />
        </div>
      </div>

      <div class="scd-form-field">
        <label class="scd-form-label">{{ 'submissionDate' | translate }} <span class="scd-required">*</span></label>
        <p-calendar [(ngModel)]="formDate" [ngModelOptions]="{standalone: true}" dateFormat="dd M yy"
          [minDate]="formDateMin" [maxDate]="formDateMax" appendTo="body" placeholder="{{ 'selectADate' | translate }}"
          styleClass="scd-form-calendar"></p-calendar>
      </div>

      <div class="scd-form-field" *ngIf="formMode === 'create'">
        <label class="scd-form-label">{{ 'addOtherClasses' | translate }}</label>
        <div class="st-empty-state" *ngIf="formSubjectId === null">
          <i class="ri-information-line"></i> {{ 'selectASubjectFirst' | translate }}
        </div>
        <div class="scd-class-chip-row" *ngIf="formSubjectId !== null">
          <button class="scd-filter-chip" *ngFor="let c of formClassOptions" [class.active]="formSelectedClassIds.includes(c.teachingClassId)" (click)="toggleFormClass(c.teachingClassId)">
            {{ classLabel(c) }}
          </button>
          <span class="st-list-sub" *ngIf="!formClassListLoading && formClassOptions.length === 0">{{ 'noOtherClassesTeachThisSubject' | translate }}</span>
        </div>
      </div>

      <div class="scd-form-field">
        <label class="scd-form-label">{{ 'uploadDocuments' | translate }}</label>
        <label class="scd-form-upload">
          <i class="ri-upload-cloud-2-line"></i>
          <span>{{ 'clickToUploadImagesOrPdfs' | translate }}</span>
          <input type="file" multiple accept="image/*,application/pdf" (change)="onFormFilesSelected($event)" hidden />
        </label>

        <div class="scd-media-grid" *ngIf="formMedia.length">
          <div class="scd-media-thumb-item" *ngFor="let m of formMedia; let i = index">
            <img *ngIf="m.type === 'IMAGE'" [src]="m.previewUrl" alt="" />
            <div class="scd-media-pdf" *ngIf="m.type === 'DOCUMENT'"><i class="ri-file-pdf-line"></i></div>
            <button class="scd-media-remove" (click)="removeFormMedia(i)"><i class="ri-close-line"></i></button>
          </div>
        </div>
      </div>
    </div>

    <div class="scd-drawer-foot">
      <button class="st-btn st-btn-secondary" (click)="closeFormDrawer()">{{ 'cancel' | translate }}</button>
      <button class="st-btn st-btn-primary" [disabled]="formSaving" (click)="submitDiaryForm()">
        {{ formSaving ? ('savingEllipsis' | translate) : ((formMode === 'create' ? 'createDiary' : 'updateDiary') | translate) }}
      </button>
    </div>
  </div>
</div>
